if($('.filter-section').length){
    mhFilter();
    document.addEventListener('ShoptetDOMContentLoaded', function() {
        mhFilter();
    }); 
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        mhFilter();
    }); 
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        mhFilter();
    }); 
    document.addEventListener('ShoptetPageFilterValueChange', function() {
      mhFilter();
  }); 
    
    
}

function mhFilter(){
    $('html').on('click', '#filters .filter-section h4', function(){
        var $currentSection = $(this).closest('.filter-section');
        $('#filters .filter-section').not($currentSection).removeClass('openIt');
        $(this).closest('.filter-section').toggleClass('openIt')
    })
    $('.slider-wrapper').append('<div class="sliderForm"></div>').addClass('filter-section');
    $('.slider-wrapper .sliderForm').append($('.slider-wrapper .slider-header'), $('.slider-wrapper .slider-content'))
    if(!$('.filter-section-boolean h4').length){
        $('.filter-section-boolean').prepend('<h4><span>Štítek</span></h4>').appendTo('#category-filter-hover');
    }

    if(!$('#category-filter-hover .extraFilter').length){
      $('#category-filter-hover').append('<div class="extraFilter"></div>');
      $('.extraFilter').html();
      $('.extraFilter').append($('.slider-wrapper'))
      $('.extraFilter').append($('.filter-section-boolean'))
      $('.extraFilter').append($('#manufacturer-filter'))
    }
    
    

    $('.filter-section form').each(function() {
        var $form = $(this);
        var $divs = $form.find('div');
        if ($divs.length > 11) {
          $divs.slice(11).hide();
          var $toggleBtn = $('<span class="toggle-filters arrowDown">Zobrazit všechny</span>');
          if(!$(this).find('.toggle-filters').length){
            $form.append($toggleBtn);
          }
          
          $toggleBtn.on('click', function() {
            if ($toggleBtn.text() === 'Zobrazit všechny') {
              $divs.show();
              $toggleBtn.text('Zobrazit méně').removeClass('arrowDown').addClass('arrowUp');
            } else {
              $divs.slice(11).hide();
              $toggleBtn.text('Zobrazit všechny').removeClass('arrowUp').addClass('arrowDown');
            }
          });
        }
      });
}